import { render, staticRenderFns } from "./ProdutoCard.vue?vue&type=template&id=60287e94&scoped=true"
import script from "./ProdutoCard.vue?vue&type=script&lang=js"
export * from "./ProdutoCard.vue?vue&type=script&lang=js"
import style0 from "./ProdutoCard.vue?vue&type=style&index=0&id=60287e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60287e94",
  null
  
)

export default component.exports